import LPResultsPage from "./LPResultsPage";

export default function LPEVEngineersResultsPage() {
  return <LPResultsPage lpSlug="ev-engineers" lpName="EV Engineers" />;
}
